export const PostCategoriesTableColumns = [
    {
        id: "nameEn",
        labelEn: "Name (EN)",
        labelAr: "الاسم (EN)",
        align: "left",
        sortable: true,
    },
    {
        id: "nameAr",
        labelEn: "Name (AR)",
        labelAr: "الاسم (AR)",
        align: "right",
        sortable: true,
    },
    {
        id: "slug",
        labelEn: "Slug",
        labelAr: "الرابط",
        align: "center",
        sortable: true,
    },
    {
        id: "parent",
        labelEn: "Parent Category",
        labelAr: "التصنيف الأب",
        align: "center",
        sortable: false,
    },
    {
        id: "created_at",
        labelEn: "Created At",
        labelAr: "تاريخ الإنشاء",
        align: "center",
        sortable: true,
    },
];
